import React from 'react';
import './style.scss';
import SVGLogo from '../../../assets/images/logo';
import Link from '../../controls/link';

interface Props {
  inverted?: boolean;
  onClick: () => any;
}

const HeaderLogo = ({ inverted = false, onClick }: Props) => (
  <Link to='/' onClick={onClick} className='app-header-logo' disableHover>
    <SVGLogo
      color={inverted ? '#000' : '#FFF'}
      className='app-header-logo-image'
    />
  </Link>
);

export default HeaderLogo;
